<template>
  <div>
    <!-- <p
      class="Text-Hero"
      v-bind:style="{
        'font-size': fontSize,
        'margin-left': marginLeft,
        width: width,
        'margin-top': marginTop,
      }"
    >
      Raih Keuntungan Hingga 20% dengan Pendanaan di Dompet Kilat
    </p>
    <img
      src="../../assets/pendanaan/Hero.webp"
      srcset="
        ../../assets/pendanaan/Hero@2x.png 2x,
        ../../assets/pendanaan/Hero@3x.png 3x
      "
      class="Hero"
    /> -->
    <v-carousel
      :show-arrows="false"
      delimiter-icon="mdi-square"
      hide-delimiters
      light
      :height="heightCarousel"
      deli
      hide-delimiter-background
    >
      <v-carousel-item v-for="(slide, i) in slides" :key="i">
        <div
          class="Text-Hero"
          v-bind:style="{
            'font-size': fontSize,
            'margin-left': marginLeft,
            width: width,
            'margin-top': marginTop,
          }"
        >
          <p>Raih Keuntungan Hingga 20% dengan Pendanaan di Dompet Kilat</p>
          <v-img
            class="gplay"
            contain
            :src="require('../../assets/homepage/Button.svg')"
            @click="note = true"
          />
        </div>

        <v-dialog
          transition="dialog-bottom-transition"
          v-model="note"
          max-width="550"
        >
          <v-card>
            <v-card-title class="white--text popupTitle">
              Download Aplikasi Dompetkilat
            </v-card-title>
            <v-card-text>
              <div class="text-h6 black--text px-2 mt-6">
                Anda akan mengunduh aplikasi DompetKilat, Pastikan anda
                <span class="red--text font-weight-bold"
                  >sudah memiliki kode akses</span
                >
              </div>
              <div class="text-h6 px-2 mt-6">
                Masukkan kode akses untuk melanjutkan

                <v-text-field
                  class="mt-2"
                  v-model="noteCode"
                  label="Kode Akses"
                  color="#D3352C"
                  outlined
                  dense
                  required
                ></v-text-field>
                <strong
                  v-if="noteError"
                  class="text-body-1 red--text text--lighten-1"
                  >Kode Akses Salah !!</strong
                >
              </div>
            </v-card-text>
            <v-divider class="mx-4" />
            <v-card-actions class="justify-end">
              <div class="pb-2">
                <v-btn
                  class="white--text text-none"
                  color="#D3352C"
                  min-width="125"
                  rounded
                  @click="closeNote"
                  >Batal</v-btn
                >
                <v-btn
                  class="ml-4 text-none"
                  min-width="125"
                  outlined
                  color="black"
                  rounded
                  @click="toDownload"
                  >Selanjutnya</v-btn
                >
              </div>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <img src="../../assets/pendanaan/Hero.svg" class="Hero" />
      </v-carousel-item>
    </v-carousel>

    <keuntungan />
    <kategori />
    <cara-kerja />
    <pertanyaan />
  </div>
</template>
<script>
import axios from "axios";
import CaraKerja from "../../components/pendanaan/CaraKerja.vue";
import Kategori from "../../components/pendanaan/Kategori.vue";
import Keuntungan from "../../components/pendanaan/Keuntungan.vue";
import Pertanyaan from "../../components/pendanaan/Pertanyaan.vue";
export default {
  components: { CaraKerja, Kategori, Keuntungan, Pertanyaan },
  data() {
    return {
      heroTextSize: `48px`,
      marginLeft: `${window.innerWidth / 8}px`,
      marginTop: `${window.innerWidth / 10}px`,
      width: `${window.innerWidth / 4}px`,
      heightCarousel: window.innerWidth / 2.25 + "px",
      fontSize: `40px`,
      note: false,
      noteError: false,
      noteCode: "",
      slides: [
        {
          title: "Mudah",
          content:
            "Proses pendanaan dan peminjaman secara online secara sederhana dan mudah dipahami",
          icon: "Mudah.png",
        },
        {
          title: "Cerdas",
          content:
            "Risiko terukur dengan menggunakan teknologi terbaru untuk menganalisis risiko",
          icon: "Cerdas.png",
        },
        {
          title: "Aman",
          content:
            "Mengantongi izin usaha resmi dan diawasi langsung oleh OJK (KEP-47/D.05/2019)",
          icon: "aman.png",
        },
        {
          title: "Keuntungan Menarik",
          content:
            "Dapatkan imbal hasil hingga 20% per tahun. Lebih tinggi dari produk investasi pada umumnya",
          icon: "keuntungan.png",
        },
        {
          title: "Dampak Sosial",
          content:
            "Membantu UMKM untuk mengembangkan usahanya dan mendorong pertumbuhan ekonomi nasional",
          icon: "sosial.png",
        },
        {
          title: "Tepercaya",
          content:
            "Menggunakan sistem pengelolaan risiko yang terintegrasi dan transparan dengan jaminan asuransi",
          icon: "terpercaya.png",
        },
      ],
    };
  },
  mounted() {
    this.onResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.resizeEventHandler);
  },
  created() {
    this.resizeEventHandler();
    window.addEventListener("resize", this.resizeEventHandler);
  },
  methods: {
    resizeEventHandler() {
      this.marginLeft = `${window.innerWidth / 8}px`;
      this.marginTop = `${window.innerWidth / 8}px`;
      this.width = `${window.innerWidth / 3}px`;
      this.fontSize = `${window.innerWidth / 40}px`;
      this.heightCarousel = window.innerWidth / 2.25 + "px";
    },
    onResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight };
    },
    toPlayStore() {
      window.location =
        "https://play.google.com/store/apps/details?id=com.dompetkilat&hl=in&gl=US";
    },
    forceFileDownload(response, title) {
      console.log(title);
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", title);
      document.body.appendChild(link);
      link.click();
    },
    download(url, title) {
      axios({
        method: "get",
        url,
        responseType: "arraybuffer",
      })
        .then((response) => {
          this.forceFileDownload(response, title);
        })
        .catch((err) => this.rollbar.debug(err));
    },
    toDownload() {
      if (this.noteCode === process.env.VUE_APP_DOWNLOAD_PASSWORD) {
        this.download(
          "https://ws-dk.dompetkilat.co.id/api/download",
          "DompetKilat_v3.0.apk"
        );
        this.noteCode = "";
        this.note = false;
        this.noteError = false;
      } else {
        this.noteError = true;
      }
    },
    closeNote() {
      this.note = false;
      this.noteCode = "";
      this.noteError = false;
    },
  },
};
</script>
<style scoped>
.Hero {
  width: 100%;
  object-fit: contain;
}
.Text-Hero {
  width: 590px;
  margin: 137px 810px 0 200px;
  font-family: Sora;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.17;
  letter-spacing: normal;
  text-align: left;
  color: #252525;
  position: absolute;
}
.gplay {
  width: 280px;
  height: 85px;
  flex-grow: 0;
  margin-left: -40px;
  cursor: pointer;
}
.popupTitle {
  background-color: #d3352c;
}
</style>
